<template>
  <!-- 适配鸿蒙去掉width -->
  <div class="contrainer">
    <!-- <div class="contrainer" :style="isPc ? 'width:1100px' : ''"> -->
    <h1>网上老年大学隐私政策</h1>
    <!-- yuan
    <p>
      <span
        >网上老年大学是由深圳金龄时代科技有限公司(注册地址为深圳市南山区粤海街道高新区社区科苑南路3156号深圳湾创新科技中心2栋A座2801)运营，涉及具体产品服务的，将由有资质的服务商提供。</span
      >
      隐私权是每个人的重要权利，网上老年大学（下称“我们”）非常重视用户个人信息和隐私的保护。在使用网上老年大学的网站或APP前，请您务必仔细阅读并透彻理解网上老年大学《隐私政策》（下称“本隐私政策”、“本政策”）。我们希望通过本隐私政策向您说明我们在您使用网上老年大学的产品与服务时如何收集、使用、保存、共享和转让这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。
      <span>如果您是18周岁以下的未成年人，</span>
      您应确保您的监护人阅读并同意本政策后，您才使用并向我们提供您的个人信息。
      <span style="text-decoration: underline"
        >若您作为网上老年大学的关联公司或合作公司、合作机构的用户登陆网上老年大学平台，访问网上老年大学网站或使用网上老年大学服务，即视为您同意本政策。</span
      >
    </p>
    <p>最近更新日期：2022年11月11日</p>
    <p>如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：</p>
    <p>电子邮件：rd@jinlingkeji.cn</p>
    <p>电 话：0755-26920484</p>
     -->
    <!-- //yore 网上老年大学APP整改 隐私政策整改 -->
    <p>
      本隐私政策由<span>深圳金龄时代科技有限公司</span>（以下简称“我们”或“App运营者”）制定并发布。我们的注册地址为<span>深圳市龙岗区坂田街道南坑社区雅兴路8号星河WORLD生态大厦5层501A、502</span>，联系电话为<span>0755-26920484</span>，电子邮箱为<span>rd@jinlingkeji.cn</span>。我们致力于保护用户的隐私权益，根据《中华人民共和国网络安全法》等相关法律法规，特此向您说明我们如何收集、使用、存储和保护您的个人信息。本隐私政策自<span>2022年11月11日</span>起生效，并可能根据法律法规的变化和业务需要进行更新。如有任何更新，我们将通过App内通知、官方网站公告等方式及时告知您。请您仔细阅读并理解本隐私政策，如您不同意本隐私政策的任何内容，请立即停止使用我们的App。
    </p>
    <h2>【特别提示】</h2>
    <p>
      为了更好保护您的个人信息，请在使用网上老年大学的产品与服务前，仔细阅读并充分了解本政策。重点内容我们已采用粗体特别提示，希望您在阅读浏览时特别关注。一旦您使用或继续使用网上老年大学产品与服务，即表示您同意我们按照本政策处理您的相关信息。
      <span>对于我们所收集的您的个人信息，我们亦用粗体的方式</span>进行了标示，
      以此向您增强式提示。一旦您同意提供您的个人信息，我们将按本政策所述的目的和方式处理您的个人信息。我们使用您的个人信息的目的是为了实现网上老年大学的产品与服务相关的功能。您有权拒绝向我们提供个人信息，但是拒绝我们收集使用这些信息可能会影响您使用相关功能。
    </p>
    <h2>目 录</h2>
    <p>一、我们如何收集和使用您的个人信息</p>
    <p>二、我们如何使用Cookie技术</p>
    <p>三、我们如何共享、转让、公开披露您的个人信息</p>
    <p>四、我们如何储存和保护您的个人信息</p>
    <!-- //yore 网上老年大学APP整改 隐私政策整改 -->
    <p>五、您如何管理您的个人信息（包括个人信息的更正、删除、注销等）</p>
    <p>六、个人信息安全投诉、举报集道</p>
    <p>七、我们如何保护未成年人的个人信息</p>
    <p>八、本政策如何更新</p>
    <p>九、如何联系我们</p>
    <h2>一、我们如何收集和使用您的个人信息</h2>
    <p>
      个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私政策中涉及的
      <span>
        个人信息包括:网络身份标识信息(包括系统账号、IP
        地址、邮箱地址及与前述有关的密码、口令、口令保护答案等)、个人常用设备信息(包括硬件型号、设备MAC
        地址、操作系统类型、软件列表惟一设备识别码(如 IMEI/android
        ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI
        信息等在内的描述个人常用设备基本情况的信息)、个人位置信息(包括精准定位信息、住址信息、经纬度、剪切板、设备序列号、传感器等)。
      </span>
      个人敏感信息是指一旦泄露、非法提供或滥用，可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视行待遇等的个人信息。
      我们仅会出于本政策以下目的，收集和使用您的个人信息：
    </p>
    <h2>（一）您须授权我们收集和使用您个人信息的情形</h2>
    <h2>1、获取网上老年大学的产品与服务所需的功能</h2>
    <h3>（1）注册成为网上老年大学用户</h3>
    <p>
      您注册成为网上老年大学用户时，
      <span
        >您需要至少向我们提供您准备使用的网上老年大学账户名即您本人的手机号码，我们将通过发送短信验证码的方式来验证您的身份是否有效。您的账户名为随机的默认昵称，您可以修改补充您的昵称、性别、地区、大学以及您的地址相关信息，这些信息均属于您的“账户信息”。</span
      >
      您补充的账户信息将有助于我们为您提供个性化的内容推荐和更优的用户体验，但如果您不提供这些补充信息，不会影响您使用网上老年大学的基本功能。
    </p>
    <h3>（2）产品与服务信息展示和搜索</h3>
    <p>
      <span
        >为了让您快速地找到您所需要的产品与服务，我们可能会收集您使用我们的产品与服务的设备信息(包括设备名称和型号、设备识别码、操作系统和应用程序版本、分辨率、服务提供商网络
        ID(PLMN))、浏览器类型等以便为您提供产品与服务展示的最优方式。我们也会为了不断改进和优化上述的功能来使用您的上述个人信息。</span
      >
    </p>
    <p>
      您也可以通过搜索来精准地找到您所需要的产品与服务。我们会保留您的搜索内容以方便您重复输入或为您展示与您搜索内容相关联的内容。
      <span
        >当您的搜索关键词信息与您的其他信息相互结合使用并可以识别您的身份时信息，在结合使用期间，我们会将您的搜索关键词信息作为您的个人信息，该种情况下您的搜索关键词与搜索历史记录将被按照本政策进行处理与保护，但无法单独识别您身份的搜索关键词本身并不属于个人信息，不适用本政策。</span
      >
    </p>
    <h3>（3）在网上老年大学下单预订</h3>
    <p>
      <span
        >保证您顺利使用您在网上老年大学上下单预订的服务，您在购买商品等业务时，您需要根据国家法律法规或服务提供的要求提供您的个人信息。这些个人信息可能包括您本人的姓名、电话号码。如果您需要提供寄送服务，您还需要提供地址、收件人姓名以及电话。前述所有信息构成您的“订单信息”，这些订单信息中将可能包含您的姓名、电话、地址等信息。</span
      >
    </p>
    <p>
      我们将使用您的订单信息来进行您的身份核验、确定交易、支付结算、为您查询订单以及提供客服咨询与售后服务；我们还会使用您的订单信息来判断您的交易是否存在异常以保护您的交易安全。
    </p>
    <p>
      如您提供的信息中含有其他用户的个人信息，您需确保您已经取得合法的授权，其中未成年人信息需要取得其监护人的授权。
    </p>
    <h3>（4）支付功能</h3>
    <p>
      在您下单后，您可以选择与网上老年大学合作的第三方支付机构(包括微信支付等支付通道，以下称“支付机构”)所提供的支付服务，支付机构此时可能需要您提供<strong>银行</strong>卡卡号、有效期、<strong>银行</strong>预留手机号、持卡人姓名、持卡人身份证件、卡验证码信息，支付功能本身并不收集您的个人信息。
    </p>
    <h3>（5）交付产品与服务功能</h3>
    <p>
      我们会通过电话、邮件、短信等形式与您确认您购买的产品与服务的相关信息，并由实际服务提供方向您交付产品或提供服务。您知晓并确认网上老年大学的关联方或与网上老年大学合作的产品与服务方会在上述环节内使用您的
      <span>订单信息</span> ，以保证能向您及时交付相关产品与服务。
    </p>
    <h3>（6）客服与售后功能</h3>
    <p>
      当您需要我们提供与您订单信息相关的客服与售后服务时，我们将会查询您的订单信息。因此，我们的电话客服和售后服务会使用您的账号信息和订单信息来对您进行身份核验。您有可能会在与我们的客服人员沟通时，提供原订单信息外的其他信息，如当您要求我们变更订单信息时。
    </p>
    <h3>（7）改进我们的产品与服务所必须的功能</h3>
    <p>
      为了提升用户体验和服务品质，我们可能会收集您的订单信息、<strong>浏览</strong>信息进行汇集和数据分析，以便可将您感兴趣的产品或服务信息展示给您;或在您搜索时向您展示您可能希望找到的内容;或与其他来源(包括第三方)的数据相匹配，从而改进我们的产品与服务。我们还可能为了提供服务及改进服务质量的合理需要而获得的您的其他信息，包括您与客服联系时您提供的相关信息，您参与网上老年大学平台活动时向我们发送的信息，以及您与我们的关联方、我们合作伙伴之间互动时我们获得的相关信息。对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为您提供高效一致的服务。
    </p>
    <h3>（8）产品业务功能所收集使用您的信息逐项列举</h3>
    <p>
      在您注册为网上老年大学用户时，至少需要提供
      <span>手机号</span> 并 <span>获取验证码</span> 用以创建网上老年大学账号。
    </p>
    <p>
      在您抽奖活动中奖时，您至少需要提供
      <span>收件人、手机号、配送地址、邮箱信息。</span>
    </p>
    <p>
      在您购买商品时，您需要提供包括
      <span>收件人、手机号、配送地址、邮箱信息。</span>
    </p>
    <h3>（9）身份认证功能</h3>
    <p>
      当您使用身份认证功能申请成为认证讲师时，我们会收集您的身份信息，包括 您的真实姓名、身份证号码、<strong>面部</strong>信息，用于证实您的个人身份。
    </p>
    <h3>（10）美颜、滤镜功能</h3>
    <p>
      当您使用网上老年大学提供的美颜或滤镜功能时，我们可能需要您的照片、相机权限或<strong>面部</strong>信息以为您提供该项服务。在客户端本地使用仅供该功能的部分<strong>面部</strong>特征值信息，以提供更好的视觉效果，在此过程中，除非另有明确说明并征得您的同意，我们不会回传、储存或共享您的任何<strong>面部</strong>特征值信息。
    </p>
    <h3>（11） 当您使用发布、评论、点赞、收藏、分享功能</h3>
    <p>
      ①为了向您提供我们最核心的信息展示服务并向您推荐可能感兴趣的作品及相关信息，我们会收集您的浏览记录（如您的关注、浏览）和点击操作记录（如点击、搜索、点赞、收藏、分享、评论、发布记录）。
    </p>
    <p>
      ②当您使用发布、编辑文字、图片、音视频功能时，我们会请求您授权照片、相机、麦克风权限。您如果拒绝授权提供，将无法使用相应功能，但不影响您正常使用网上老年大学的其他功能。
    </p>
    <p>
      ③当您使用发布、评论、点赞、收藏、分享功能时，
      您发布的文字、照片、视频、音频、评论、点赞、收藏、分享记录信息会存储在我们的服务器中
      ，因为存储是实现这一功能所必需的。我们会以加密的方式存储，您也可以随时删除这些信息。
    </p>
    <h3>(12)互动功能与服务</h3>
    <p>
      当您关注您感兴趣的账号、进行浏览、评论、点赞、收藏、分享内容时，我们会收集您关注的账号和前述信息 ，并向您展示您关注账号发布的内容。
    </p>
    <h3>(13)消息通知</h3>
    <p>
      ①为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的广播信息，本应用须使用(自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。
    </p>
    <p>
      ②当您打开网上老年大学APP内容类推送消息，在征得您的明确同意后，会跳转网上老年大学APP打开相关内容。在未征得您同意的情况下，则不会有关联启动。
    </p>
    <p>
      ③我们在运营中可能会通过你在使用产品及/或服务的过程中所提供的联系方式（例如：电话号码），向你同时发送一种或多种类型的通知，以短信、电话的方式，为你提供你可能感兴趣的服务、功能或活动等商业性信息。但请你放心，如你不愿接受这些信息，你可以通过手机短信中提供的退订方式进行退订，也可以直接与我们联系进行退订。
    </p>
    <p>
      ④为与您使用的设备适配消息推送功能，设备制造商（腾讯信鸽、华为、小米、OPPO、VIVO、魅族等）会使用您的设备型号、版本与相关设备信息，
      <strong>具体请查看</strong>
      <router-link tag="span" :to="{ name: 'sdkPage' }" class="sdkTap">
        《第三方SDK收集使用信息说明》 </router-link
      >。
    </p>
    <h2>2、提供安全保障所必须的功能</h2>
    <p>
      为提高您使用我们以及我们关联公司或合作伙伴提供的产品与服务时系统的安全性，更准确地预防钓鱼网站或
      <span>APP</span>
      欺诈、计算机病毒、网络攻击、网络侵入以及保护账户安全，我们可能会通过了解您的
      <span>浏览信息、订单信息、交易信息、设备应用安装列表</span>
      来综合判断您账户和交易风险、检测和防范安全事件，并可能会记录一些我们认为有风险的链接(“
      <span>URL</span>
      ”);我们也会收集您的设备信息对于网上老年大学系统问题进行分析、统计流量并排查可能存在的风险并依法采取必要的记录、审计、分析、处置措施。
    </p>
    <h2>3、需另行征得您的授权同意</h2>
    <p>
      当我们要将信息用于本政策未载明的其它用途时，会事先征求您的同意。当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。
    </p>
    <h2>（二）无需征得您授权同意可收集、使用您个人信息的情形</h2>
    <p>
      根据相关法律法规、监管要求及国家标准，在以下情形中，我们可以在不征得您的授权同意情况下收集、使用一些必要的个人信息：
    </p>
    <p>（1）与我们履行法律法规规定的义务相关的；</p>
    <p>（2）与国家安全、国防安全直接相关的；</p>
    <p>（3）与公共安全、公共卫生、重大公共利益直接相关的；</p>
    <p>（4）与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
    <p>
      （5）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
    </p>
    <p>（6）所涉及的个人信息是您自行向社会公众公开的；</p>
    <p>（7）根据您与我们签订和履行合同所必需的；</p>
    <p>
      （8）从合法公开披露的信息中收集到您的个人信息，如从合法的新闻报道、政府信息公开等渠道；
    </p>
    <p>
      （9）用于维护我们产品与服务的安全稳定运行所必需的，例如发现、处置产品与服务故障；
    </p>
    <p>
      （10）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
    </p>
    <p>
      （11）出于公共利益开展统计或学术研究所必需，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
    </p>
    <p>（12）法律法规规定的其他情形。</p>
    <h2>（三）您可选择是否授权我们收集和使用您的个人信息的情形</h2>
    <p>
      1、为提升用户体验，使网上老年大学的产品与服务更人性化，我们的以下附加功能中可能会收集和使用您的个人信息。如果您不提供这些个人信息，您依然可以使用网上老年大学的其他产品与服务，这些附加功能包括：
    </p>
    <p>
      <span>（1）基于位置信息的个性化推荐功能:</span>
      我们会收集您的位置信息(我们仅收集您当时所处的地理位置，但不会将您各时段的位置信息进行结合以判断您的行踪轨迹)来判断您所处的地点，自动为您推荐您所在区域的内容。
    </p>
    <p>
      <span>（2）基于图片上传的附加功能：</span>
      您可以在网上老年大学平台上传您的照片，如您可在上传图文的同时上传您的相片，您也可上传您的其他照片来实现图文分享功能。
    </p>
    <p>
      <span>（3）基于语音技术的附加功能：</span>
      您可以在网上老年大学平台使用搜索和评论时使用语音输入，如您未授权，将无法使用语音搜索和语音输入相关功能，但除此外的其他功能仍然可以正常使用，我们本地不会对您录制的信息做收集等操作。
    </p>
    <p>
      <span>（4）基于健康数据的附加功能：</span>
      您可以在网上老年大学平台使用打卡时使用运动步数。
    </p>
    <p>
      <span>（5）基于定位数据的附加功能：</span>
      当您开启设备定位功能并使用网上老年大学基于位置提供的相关服务（含发布功能的定位标签、打卡功能、附近功能）时，我们可能会收集有关
      您的GPS位置信息。GPS位置信息属于个人敏感信息，拒绝提供该信息您将无法使用上述基于位置提供的相关服务
      ，但不影响您正常使用网上老年大学的其他功能。
    </p>
    <p>
      <span>（6）基于监听用户手机安装和卸载应用的附加功能：</span>
      您下载安装本应用成功后应用市场会删除安装包，以及在强制更新场景下，安装应用市场后进行弹出版本更新框，此功能仅针对于本应用市场进行监听，其他应用包名不涉及，也不会上报额外的应用信息。
    </p>
    <!-- //yore 网上老年大学APP整改 隐私政策整改 -->
    <p>
      2、为了向您提供更加精准和个性化的服务，我们可能需要申请访问您的设备或应用中的某些权限，并请求您提供一些个人敏感信息。我们申请这些权限和请求这些信息的目的如下：
    </p>
    <p>
      <span>（1）权限申请:</span>
      我们可能需要访问您的位置信息、相机、麦克风和存储等权限，以便提供基于位置的服务、拍照/录像/录音功能、保存文件等功能。
    </p>
    <p>
      <span>（2）个人敏感信息收集:</span>
      在提供某些服务时，我们可能需要您提供身份证号码、银行卡信息等敏感信息，以用于身份验证、支付交易处理等目的。
    </p>
    <p>
      我们承诺，我们仅会按照本隐私协议中所述的目的使用您的个人信息，并会采取必要的安全措施来保护这些信息的安全。我们不会将您的个人信息用于任何未经您明确同意的用途。如果您对我们的权限申请或信息收集有任何疑问或担忧，请随时与我们联系。
    </p>
    <p>
      3、上述第1项附加功能可能需要您在您的设备中向我们开启您的
      <span
        >地理位置（位置信息）、相机（摄像头）、相册（图片库）、麦克风、健康数据的访问权限，</span
      >
      以实现这些功能所涉及的信息的收集和使用。您可以在通过设置找到应用程序详情，点击进入权限查看找到您上述权限开启的状态，并可以决定将这些权限随时开启或关闭。
      <span
        >请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。</span
      >
    </p>
    <h2>（四）我们从第三方获得您个人信息</h2>
    <p>
      我们可能会在您的授权同意范围内从第三方（我们的合作方）处收集并使用您的个人信息。我们会将依据与第三方的约定并对个人信息来源的合法性进行确认后，在符合相关法律法规前提下，使用您的这些个人信息，同时请您详细阅读该第三方的隐私政策及用户协议。如您拒绝第三方在提供服务时收集、使用或者传递您的个人信息，将可能导致您无法使用网上老年大学对应的产品与服务。
    </p>
    <h2>（五）您个人信息使用的规则</h2>
    <p>
      1、我们会根据本隐私政策的约定并为实现我们的产品与服务功能对所收集的个人信息进行使用。当我们要将您的个人信息用于本政策未载明的其它用途时，会通过事先征求您的授权同意。
    </p>
    <p>
      2、在收集您的个人信息后，在我们对您的个人信息进行去标识化处理，去标示化处理的信息将无法识别主体。请您注意，在此情况下我们有权使用已经去标示化的信息，在不透漏您个人信息的前提下，我们可对去标识化处理后的用户数据库进行分析并予以商业化的利用。
    </p>
    <p>
      3、请您注意，您在使用我们的产品与服务时，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的产品与服务期间将持续授权我们使用。
    </p>
    <p>
      4、我们会对我们的产品与服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。
    </p>
    <p>
      5、如果我们发生合并、收购或破产清算可能涉及到个人信息转让时，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束。
    </p>
    <p>6、对用于画像的个人信息使用的应用场景及可能对您产生的影响逐项列举:</p>
    <p>
      ①未经您的同意，我们不会共享您的个人信息，除非共享的个人信息是去标识化处理后的信息，且共享第三方无法重新识别此类信息的自然人主体。如果第三方使用信息的目的超越原授权同意范围，他们需要重新征得您的同意。
    </p>
    <p>
      ②合法正当与最小必要原则：
      共享的数据必须具有合法正当目的，且共享的数据以达成目的必要为限。
    </p>
    <p>
      ③安全审慎原则：
      我们将审慎评估第三方使用共享信息的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全。
    </p>
    <table border="1" class="table">
      <tr>
        <td style="width: 20%">应用场景</td>
        <td style="width: 80%">业务功能及影响</td>
      </tr>
      <tr>
        <td>推荐</td>
        <td>
          根据用户
          <span>浏览、搜索、购物、互动记录</span> 个性化推荐展示
          相关的课程、内容、热门话题、相似内容
        </td>
      </tr>
      <tr>
        <td>搜索</td>
        <td>
          根据用户 在匹配用户搜索结果时，根据
          <span>浏览、搜索</span> 、匹配更相关的搜索结果
        </td>
      </tr>
      <tr>
        <td>广告</td>
        <td>
          根据用户
          <span>浏览、搜索、互动记录</span> 匹配展示营销活动
        </td>
      </tr>
      <tr>
        <td>推送</td>
        <td>
          根据用户
          <span>浏览、搜索、互动记录</span>推送相关的内容、消息或营销活动
        </td>
      </tr>
    </table>

    <h2>二、我们如何使用Cookie技术</h2>
    <p>
      为确保网站或APP正常运转，我们会在您的计算机或移动设备上储存名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，
      <span>网站或APP能够储存您的偏好数据。</span>
      我们不会将Cookie用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。有关详情，请参见AboutCookies.org。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问我们的网站或APP时更改用户设置。
    </p>
    <h2>三、我们如何共享、转让、公开披露您的个人信息</h2>
    <h3>（一）共享</h3>
    <p>
      <span
        >1、我们可能会向关联公司等第三方共享您的订单信息、账户信息、设备信息以及位置信息，以保障为您提供的产品与服务顺利完成。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的关联公司无权将共享的个人信息用于任何其他用途。</span
      >
    </p>
    <p>
      所谓关联公司是指与我们有关的任何直接或间接（通过一个或一个以上的中介或协议安排）控制该方或被该方控制、或与该方共同受控制的任何个人、合伙、组织或实体。“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。
    </p>
    <p>
      如果您拒绝我们的关联公司在提供服务时收集为提供服务所必须的个人信息，将可能导致您无法使用网上老年大学通过该合作方提供的产品与服务。
    </p>
    <h3>
      2、除上述第1种情况外，我们不会与任何公司、组织和个人共享您的个人信息，但以下情况除外：
    </h3>
    <p>
      （1）事先获得您的明确授权或同意：获得您的明确同意后，我们会与其他方共享您的个人信息；
    </p>
    <p>
      （2）在法定情形下的共享：根据适用的法律法规、法律程序、诉讼/仲裁、政府的强制命令、监管要求而需共享您的个人信息；
    </p>
    <p>
      （3）在法律要求或允许的范围内，为了保护您或社会公众的利益、财产或安全免遭损害而有必要提供您的个人信息给第三方（含消费者权益保护部门等行业组织）；
    </p>
    <p>
      （4）为了保护国家安全、公共安全以及您和其他个人的重大合法权益而需要共享您的个人信息；
    </p>
    <p>（5）您自行公开的或者我们能从其他合法公开渠道获取到您的个人信息。</p>
    <h3>3、第三方SDK的使用:</h3>
    <p>
      为保障我们客户端的稳定运行、功能实现，使您能够使用和享受更多的服务及功能，我们的应用中会嵌入授权合作伙伴的SDK或其他类似的应用程序。此时，第三方SDK服务商可能会收集您的相关信息。具体请查看<router-link
        tag="span"
        :to="{ name: 'sdkPage' }"
        class="sdkTap"
        >《第三方SDK收集使用信息说明》</router-link
      >。
    </p>
    <h3>（二）转让</h3>
    <p>我们不会将您的个人信息转让给任何公司、组织或个人，除非发生下列情况：</p>
    <p>（1）事先获得您的明确同意；</p>
    <p>
      （2）根据所适用的法律法规、行业规定、法律程序要求、诉讼/仲裁、政府的强制命令、监管要求所必须要求提供的；
    </p>
    <p>
      （3）为了保护国家安全、公共安全以及您和其他个人的重大合法权益而需要转让您的个人信息；
    </p>
    <p>（4）您自行公开的或者我们能从其他合法公开渠道获取到您的个人信息。</p>
    <p>
      <span
        >如果发生合并、收购或破产清算，将可能涉及到个人信息转让，此种情况下我们会要求新的持有您个人信息的公司、组织继续受本政策的约束。如果本政策中约定的个人信息的收集、处理方式发生任何改变，该公司、组织将重新向您征求授权同意。</span
      >
    </p>
    <h3>（三）公开披露</h3>
    <p>
      除非获取您的明确同意，我们不会公开披露您的个人信息。基于法律、法律程序、诉讼或政府主管部门强制性要求的情况下，为了保护国家安全、公共安全以及您和其他个人的重大合法权益，我们可能会向有权机关或公众披露您的个人信息。但我们保证，在上述情况发生时，我们会要求披露请求方必须出具与之相应的有效法律文件，并对被披露的信息采取符合法律和业界标准的安全防护措施。
    </p>
    <p>
      您发布话题、照片、视频等内容信息的或评论，对任何访问网上老年大学或APP的第三方均是公开的。请注意所有这些公开的信息可能会被公众阅读，请您在决定公开含有您个人信息及评论前慎重考虑。
    </p>
    <h3>四、我们如何储存和保护您的个人信息</h3>
    <h2>（一）您个人信息的储存</h2>
    <p>
      您的个人信息将全被储存于中华人民共和国境内，储存位置包括网上老年大学及其关联公司的服务器，或网上老年大学委托机构的服务器。我们会采取合理可行的措施，尽力避免收集无关的个人信息。
      <span
        >我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求。例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。而我们判断前述期限的标准包括:</span
      >
    </p>
    <p>
      <span
        >完成与您相关的交易目的、维护相关交易及业务记录、应对可能的查询或投诉;</span
      >
    </p>
    <p>
      <span>保证我们为您提供的服务安全及质量;</span>
    </p>
    <p>
      <span>您是否同意更长的留存期限;</span>
    </p>
    <p>
      <span>是否存在保留期限的其他特别约定。</span>
    </p>
    <p>
      <span
        >请您注意，在您的个人信息超出保留期间（【】）后，我们会根据适用法律的要求删除您的个人信息或匿名化处理;此外，在注销账户后，我们将停止为您提供产品和服务，并根据您的要求，删除您的个人信息或匿名化处理，法律法规另有规定的除外。</span
      >
    </p>
    <h2>（二）我们保护您个人信息的技术与措施</h2>
    <p>
      我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：
    </p>
    <h3>1、数据安全技术措施</h3>
    <p>
      我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问、公开披露、使用、修改，避免数据的损坏或丢失。
    </p>
    <p>
      网上老年大学的网络服务采取了传输层安全协议等加密技术，通过https等方式提供浏览服务，确保用户数据在传输过程中的安全。
    </p>
    <p>
      网上老年大学采取加密技术对用户个人信息进行加密保存，并通过隔离技术进行隔离。
    </p>
    <p>
      在个人信息使用时，例如个人信息展示、个人信息关联计算，我们会采用包括内容替换、SHA256
      和 FPE在内多种数据脱敏技术增强个人信息在使用中安全性。
    </p>
    <p>
      网上老年大学采用严格的数据访问权限控制和多因素身份认证技术以及数据防泄漏技术保护个人信息，避免数据被违规使用。
    </p>
    <p>
      网上老年大学采用代码安全自动检查、数据访问日志分析、系统访问权限审计、数据访问流量审计技术进行个人信息安全审计。
    </p>
    <h3>2、网上老年大学为保护个人信息采取的其他安全措施</h3>
    <p>
      网上老年大学通过建立数据分类分级制度、数据安全管理规范、个人信息保护与合规总则、用户信息安全展示规范、安全开发规范、代码发布规范来管理规范个人信息的储存和使用。
    </p>
    <p>
      网上老年大学通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。
    </p>
    <p>
      加强安全意识。我们还会定期举报信息安全意识和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
    </p>
    <p>
      3、我们仅允许有必要知晓这些信息的网上老年大学及网上老年大学关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与网上老年大学的合作关系。
    </p>
    <p>
      4、我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。
    </p>
    <p>
      <span
        >5、网上老年大学的网站或APP、产品、或服务中可能含有到其他网站或APP的链接，我们提醒您，网上老年大学对其他网站或APP的隐私保护措施无法做出承诺和保证。但是，我们网站或APP的页面有显著的“网上老年大学”标记，您可以据此判断是否跳转至外部链接。</span
      >
    </p>
    <p>
      <span
        >6、互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时，请注意保护您的个人信息安全。</span
      >
    </p>
    <p>
      <span
        >7、互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。</span
      >
    </p>
    <p>
      <span
        >8、在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。</span
      >
    </p>
    <!-- //yore 网上老年大学APP整改 隐私政策整改 -->
    <h2>五、您如何管理您的个人信息（包括个人信息的更正、删除、注销等）</h2>
    <p>
      网上老年大学非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：
    </p>
    <h3>
      1、网上老年大学非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：
    </h3>
    <p>
      您有权访问和更正您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：
    </p>
    <p>
      （1）
      <span>您的账户信息</span>
      ：移动端具体路径为：首页--“我的”—“个人资料”；首页--“我的”—“我的收藏“。
    </p>
    <p>
      （2）
      <span>您的订单信息</span>
      移动端具体路径为：移动端首页--“我的健康”--“健康生活”--“我的”--订单。您可以选择删除已经完成的订单来删除您的订单信息，但这样可能导致我们无法准确判断您的购买信息而难以提供相应的售后服务。
    </p>
    <p>
      （3）
      <span>您的浏览信息</span
      >您可以访问或清除您的搜索历史记录、查看和修改以及管理其他数据。移动端路径为：首页--“我的”—学习历史；兴趣及其他数据：首页--“我的”—我的收藏。
    </p>
    <p>
      （4）您无法访问和更正的个人信息：除上述列明的信息外，您的部分个人信息我们还无法为您提供访问和更正的服务，这些信息主要是为了提升您的用户体验和保证交易安全所收集的您的设备信息、您使用附加功能时产生的个人信息。上述信息我们会在您的授权范围内进行使用，您无法访问和更正，但您可联系我们进行删除或做匿名化处理。
    </p>
    <h3>2、删除您的个人信息</h3>
    <p>
      您在我们的产品与服务页面中可以直接清除或删除的信息，包括订单信息、<strong>浏览</strong>信息、收货地址、作品信息；
    </p>
    <h3>2.1删除信息</h3>
    <p>
      （1）【APP-我的-个人主页-作品】，点击查看对应的作品，点击更多的按钮，可通过弹窗内容的[删除]，对内容进行删除。
    </p>
    <p>（2）【APP-学习-免费课程】，左滑课程，可对课程进行删除。</p>
    <p>（3）【APP-我的-我的收藏】，进入课程列表，点击[已收藏]，可取消收藏；</p>
    <p>（4）【APP-我的-个人主页-我的关注】，点击[已关注]，可取消关注</p>
    <p>（5）【APP-同学圈-作品】，点击已[点赞]作品，可取消点赞；</p>
    <p>（6）【APP-同学圈-作品-评论】，查看[评论内容]下的删除，可删除评论；</p>
    <h3>2.2在以下情形中，您可以向我们提出删除个人信息的请求：</h3>
    <p>（1）如果我们处理个人信息的行为违反法律法规；</p>
    <p>（2）如果我们收集、使用您的个人信息，却未征得您的同意；</p>
    <p>（3）如果我们处理个人信息的行为违反了与您的约定；</p>
    <p>（4）如果您不再使用我们的产品与服务，或您注销了账号；</p>
    <p>（5）如果我们不再为您提供我们的产品与服务。</p>
    <p>
      若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。
      <span
        >当您从我们的服务中删除信息后，因为适用的法律要求或安全技术原因，我们可能无法立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息或实现匿名。</span
      >
    </p>
    <h3>3、注销账户</h3>
    <p>
      <span
        >您可以在我们的产品中申请注销账户。您可通过以下方式自行操作：您可以登陆移动端，我的-个人设置-账号与安全-注销账号，提出“注销账号”申请。申请受理成功后，您注销账户后，我们将停止为您提供产品与服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息。</span
      >
    </p>
    <h3>4、响应您的请求</h3>
    <p>
      为了保障安全，我们可能需要您提供书面请求，或以其他方式证明您的身份，我们将在收到您反馈并验证您的身份后的
      15
      天内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段(例如，需要开发新系统或从根本上改变现行惯例)、给他人合法权益带来风险或者非常不切实际(例如，涉及备份磁带上存放的信息)的请求，我们可能会予以拒绝。
    </p>
    <p>在以下情形中，按照法律法规要求，我们将无法响应您的请求</p>
    <p>（1）与国家安全、国防安全有关的；</p>
    <p>（2）与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>（3）与犯罪侦查、起诉和审判和判决执行等有关的；</p>
    <p>（4）有充分证据表明您存在主观恶意或滥用权利的；</p>
    <p>（6）涉及商业秘密的。</p>
    <h3>5、如果您不想接受我们给您发送的促销信息，您随时可通过以下方式取消：</h3>
    <p>（1）您可以随时回复“TD”来取消我们给您发送的手机促销短信。</p>
    <p>
      （2）您可以通过移动端APP“账户设置-设置-推送消息设置-通知”设置是否接受我们通过“通知”推荐给您的商品和促销信息
    </p>
    <p>
      （3）为了保护您的隐私，我们不会以任何方式和途径向您推送涉及宗教信仰、性、疾病等相关敏感内容的促销或商品信息给您。
    </p>
    <!-- //yore 网上老年大学APP整改 隐私政策整改 -->
    <h3>六、个人信息安全投诉、举报集道</h3>
    <p>
      我们深知个人信息安全的重要性，因此建立了专门的个人信息安全投诉、举报渠道。您可以通过以下方式向我们反馈问题或提出投诉、举报：
    </p>
    <p>
      1、访问我们的官方网站或APP，在“个人设置-意见反馈”或“联系客服”页面找到相关的投诉、举报入口。
    </p>
    <p>2、拨打我们的客服热线0755-26920484，与客服人员进行沟通。</p>
    <p>
      3、发送电子邮件至<span>rd@jinlingkeji.cn</span>，详细描述您的问题或投诉内容，并附上相关证据。
    </p>
    <p>
      4、如果您关注了我们的微信公众号或使用了我们的小程序，也可以通过其中的“联系客服”功能进行投诉、举报。
    </p>
    <p>
      我们在收到您的投诉、举报后，将按照接收与记录、初步核实、深入调查、处理与反馈、持续改进的流程进行处理，并努力提升我们的个人信息保护措施。如果您对我们的处理有任何疑问或担忧，请随时与我们联系。
    </p>
    <h3>七、我们如何保护未成年人的个人信息</h3>
    <p>
      1、网上老年大学非常重视对未成年人个人信息的保护。
      <span
        >若您是18周岁以下的未成年人，在使用我们的产品与服务前，应事先取得您家长或法定监护人的书面同意。网上老年大学根据国家相关法律法规的规定保护未成年人的个人信息。</span
      >
    </p>
    <p>
      若您是18周岁以下的未成年人，在使用我们的产品与服务前，应事先取得您家长或法定监护人的书面同意。网上老年大学根据国家相关法律法规的规定保护未成年人的个人信息。
    </p>
    <p>
      <span
        >3、如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。</span
      >
    </p>
    <p>
      <span
        >4、如您是14周岁以下的儿童，我们依照本政策保护未成年人信息的同时，还将按照《儿童个人信息网络保护规定》等相关规定，对14周岁以下儿童的个人信息进行保护。</span
      >
    </p>
    <h3>八、本政策如何更新</h3>
    <p>
      1、我们的隐私政策可能变更。除非出现重大变更情形，我们承诺不会削减您依据本隐私政策所应享有的权利。当本政策发生变更时，我们会在网上老年大学或APP上提前以公告、弹窗或以其他适当方式向您展示变更后的政策。未经您同意，我们不会限制您按照政策所应享有的相关权利。
    </p>
    <p>
      2、对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。
    </p>
    <p>本政策所指的重大变更包括但不限于：</p>
    <p>
      （1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
    </p>
    <p>（2） 个人信息安全影响评估报告表明存在高风险时。</p>
    <p>（3）个人信息共享、转让或公开披露的主要对象发生变化；</p>
    <p>
      3、
      <span
        >请您注意，只有在获取您的同意后，我们才会按照更新后的政策收集、使用、处理和储存您的个人信息。</span
      >
      您可以选择不同意，这可能导致您无法完整使用网上老年大学的产品与服务。
    </p>
    <h2>九、如何联系我们</h2>
    <p>
      <span
        >如您对本隐私政策有任何疑问、意见或建议，请通过以下方式与我们联系：</span
      >
    </p>
    <p>电话：0755-26920484</p>
    <p>邮箱:rd@jinlingkeji.cn</p>
    <p>
      <span>2、一般情况下，我们将在十五天内回复。</span>
    </p>
    <p>
      <span>注：本政策将于2022年11月11日正式生效。</span>
    </p>
  </div>
</template>

<script>
export default {
  name: "yinsi",
  data() {
    return {
      isPc: true,
    };
  },
  mounted() {
    this.isPc = this.modoule();
  },
  methods: {
    modoule() {
      var userAgentInfo = navigator.userAgent;
      var Agents = new Array(
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      );
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
  },
};
</script>

<style lang="scss" scoped>
.contrainer {
  padding: 20px;
  padding-top: 0;
  margin: 0 auto;
  overflow-x: auto;
}
h1 {
  font-size: 16pt;
  font-family:
    PingFangSC-Medium,
    PingFang SC;
  font-weight: 700;
  color: black;
  line-height: 16.5pt;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
h2 {
  font-size: 15pt;
  font-family:
    PingFangSC-Medium,
    PingFang SC;
  font-weight: 600;
  color: black;
  line-height: 16.5pt;
  margin: 10px 0;
}
h3 {
  font-size: 15pt;
  font-family:
    PingFangSC-Medium,
    PingFang SC;
  font-weight: 500;
  color: black;
  line-height: 16.5pt;
  margin: 10px 0;
}
p {
  font-size: 12.5pt;
  font-family:
    PingFangSC-Regular,
    PingFang SC;
  font-weight: 400;
  color: black;
  line-height: 18.5pt;
  text-align: justify;
  text-indent: 2.66vw;
  span {
    font-weight: 600;
  }
}
.tableBox {
  width: 100vw;
  padding-right: 1.875rem;
  overflow: hidden;
}
.table {
  width: 100%;
  text-align: center;
  font-size: 12.5pt;
  font-family:
    PingFangSC-Regular,
    PingFang SC;
  font-weight: 400;
  color: black;
  line-height: 30px;
  margin: 20px 0;
  td {
    padding: 20px;
    white-space: normal;
    word-break: break-all;
    box-sizing: border-box;
  }
  span {
    font-weight: bold;
  }
}
.sdkTap {
  font-weight: 400;
  color: #5b92e1;
  cursor: pointer;
}
</style>
